import { initializeApp }  from "firebase/app";
import { getFirestore }   from "firebase/firestore";
import { getFunctions }   from "firebase/functions";
import { getAuth, initializeAuth, indexedDBLocalPersistence } from "firebase/auth";

const firebaseConfig = {
  apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:             process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId:     process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const app       = initializeApp(firebaseConfig);
export const db        = getFirestore(app);
export const functions = getFunctions(app);

// Capacitor iOS WebView needs indexedDB persistence or auth hangs
const isNative = window.Capacitor?.isNativePlatform?.() || false;
export const auth = isNative
  ? initializeAuth(app, { persistence: indexedDBLocalPersistence })
  : getAuth(app);